import lodashGet from 'lodash/get';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Drawer, SvgIcon } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  Dashboard,
  Equalizer,
  Folder,
  GpsFixed,
  People,
  Settings,
  Person,
  Book,
  Description,
} from '@mui/icons-material';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';

import MenuItemLink from './menuItemLink';
// import { useToggleSidebar } from '../store/ui';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { TenantContext } from '../orbit-context';

export const DRAWER_WIDTH = 192;
export const CLOSED_DRAWER_WIDTH = 85;

const useStyles = makeStyles(
  theme => ({
    drawerPaper: {
      position: 'relative',
      height: '100%',
      overflowX: 'hidden',
      width: (props: { open?: boolean }) =>
        props.open
          ? lodashGet(theme, 'sidebar.width', DRAWER_WIDTH)
          : CLOSED_DRAWER_WIDTH, //lodashGet(theme, 'sidebar.closedWidth', CLOSED_DRAWER_WIDTH ),
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: 'transparent',
      [theme.breakpoints.only('xs')]: {
        marginTop: 0,
        height: '100vh',
        position: 'inherit',
        backgroundColor: theme.palette.background.default,
      },
      [theme.breakpoints.up('md')]: {
        border: 'none',
      },
      zIndex: 'inherit',
      paddingTop: theme.spacing(2)
    },
    paper: {
      background: theme.palette.common.white,
    }
  }),
  { name: 'OrbitSidebar' }
);
function HomeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}
const ConsoleSidebar = () => {
  const { url } = useRouteMatch();
  const [t] = useTranslation();
  const tenant = useContext(TenantContext);
  return (
    <>
      <MenuItemLink to={`${url}/dashboard`}
        primaryText={t('menu.dashboard')}
        sidebarIsOpen={true}
        leftIcon={<HomeIcon fontSize="small" />}
        dense
      />
      {tenant.pcstautscode && <MenuItemLink to={`${url}/products`}
        primaryText={t('menu.productsManage')}
        sidebarIsOpen={true}
        leftIcon={<Dashboard fontSize="small" />}
        dense
      />}
      {tenant.pcstautscode && <MenuItemLink to={`${url}/articals`}
            primaryText={t('menu.articals')}
            sidebarIsOpen={true}
            leftIcon={<Description fontSize="small" />}
            dense
          />}
      <MenuItemLink to={`${url}/documents`}
        primaryText={t('menu.documents')}
        sidebarIsOpen={true}
        leftIcon={<Folder fontSize="small" />}
        dense
      />
      <MenuItemLink to={`${url}/campaign`}
        primaryText={t('menu.campaign')}
        sidebarIsOpen={true}
        leftIcon={<SvgIcon  fontSize="medium" > <path d="M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"/></SvgIcon>}
        dense
      />
      <MenuItemLink to={`${url}/members`}
        primaryText={t('menu.members')}
        sidebarIsOpen={true}
        leftIcon={<People fontSize="small" />}
        dense
      />
      <MenuItemLink to={`${url}/stats`}
        primaryText={t('menu.stats')}
        sidebarIsOpen={true}
        leftIcon={<Equalizer fontSize="small" />}
        dense
      />
      {/* myApplet */}
      <MenuItemLink to={`${url}/myapplet`}
        primaryText={t('menu.myApplet')}
        sidebarIsOpen={true}
        leftIcon={<AllInclusiveIcon fontSize="small" />}
        dense
      />
      <MenuItemLink to={`${url}/icatalog`}
        primaryText={'智能样本eCatalog'}
        sidebarIsOpen={true} 
        leftIcon={<AllInclusiveIcon fontSize="small" />}
        dense
      />
       {tenant?.tntindex==='Mitsubishi'&&<MenuItemLink to={`${url}/externalDatabase`}
        primaryText={t('menu.externalDatabase')}
        sidebarIsOpen={true}
        leftIcon={<Book fontSize="small" />}
        dense
      />}
      <MenuItemLink to={`${url}/settings`}
        primaryText={t('menu.settings')}
        sidebarIsOpen={true}
        leftIcon={<Settings fontSize="small" />}
        dense
      />
      {/* <MenuItemLink to={`${url}/account`}
        primaryText={t('menu.account')}
        sidebarIsOpen={true}
        leftIcon={<AccountBalanceWallet fontSize="small"/>}
        dense
      /> */}
    </>
  );
};

const Sidebar = (props) => {
  const {
    ...rest
  } = props;
  // const [toggleSidebar, open] = useToggleSidebar();
  const { drawerPaper, ...classes } = useStyles({ ...props, open: false });
  const [t] = useTranslation();
  const tenant = useContext(TenantContext);

  // console.log('side bar ===== 1', tenant)

  return (
    <Drawer
      variant="permanent"
      // open={open}
      open
      PaperProps={{className: drawerPaper}}
      // onClose={toggleSidebar}
      classes={classes}
      {...rest}
    >
      <Switch>
        <Route path='/console'>
          <ConsoleSidebar />
        </Route>
        <Route>
          <MenuItemLink to="/documents"
            primaryText={t('menu.documents')}
            sidebarIsOpen={true}
            leftIcon={<Folder fontSize="small" />}
            dense
          />
          {tenant.pcstautscode && <MenuItemLink to={'/products'}
            primaryText={t('menu.products')}
            sidebarIsOpen={true}
            leftIcon={<Dashboard fontSize="small" />}
            dense
          />}
          
          <MenuItemLink to="/favorites"
            primaryText={t('menu.favorites')}
            sidebarIsOpen={true}
            leftIcon={<Folder fontSize="small" />}
            dense
          />
          <MenuItemLink to="/tracking"
            primaryText={t('menu.tracking')}
            sidebarIsOpen={true}
            leftIcon={<GpsFixed fontSize="small" />}
            dense
          />
          <MenuItemLink to="/settings"
            primaryText={t('menu.my')}
            sidebarIsOpen={true}
            leftIcon={<Person fontSize="small"/>}
            dense
          />
        </Route>
      </Switch>
    </Drawer>
  );
};

export default Sidebar;
